const state = {
	step: 0,
	history:[]
}

const getters = {
	step: state => state.step,
	history: state => state.history
}

const actions = {
	next({commit},payload) {
		commit('nextQuestion',payload)
	}
}

const mutations = {
	nextQuestion(state,payload) {
		state.step = payload;
		state.history.push(payload);
		if(payload == 0){
			state.history=[];
		}
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}